<nav class="sticky top-0 z-30 border-b border-border-strong bg-bg-base/85 backdrop-blur-md shadow-elevated">
  <div class="mx-auto max-w-7xl overflow-x-auto px-3 sm:px-6 lg:px-8">
  <ul class="flex justify-start lg:justify-center relative min-w-max">

    <!-- Active underline animated -->
    <span class="absolute bottom-0 h-[2px] bg-primary rounded-t-full transition-all duration-300 shadow-glow"
      [style.width.px]="activeTabWidth" [style.left.px]="activeTabLeft"></span>

    <li class="me-1" *ngFor="let tab of tabs; let i = index" #tabRef>
      <button (click)="onTabClick(tab.id)"
        class="tab-btn relative inline-flex items-center px-4 sm:px-5 py-4 rounded-lg transition-all duration-200 hover:text-primary hover:bg-surface-hover whitespace-nowrap font-mono tracking-wide uppercase text-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-bg-base"
        [ngClass]="isActiveTab(tab.id) ? 'text-primary bg-primary-soft font-bold' : 'text-text-secondary'">
        {{ tab.title | translate }}
      </button>
    </li>

  </ul>
  </div>
</nav>
